export default "__VITE_ASSET__DXTWZxXr__"